<template>
    <section class="">
          <div class="level-item">
        <img src="https://cdn.fcglcdn.com/brainbees/intelli/intellitots/images/Intellitots-logo.png" />

      </div>
<div class="level-item">
<p class="title is-2">Online Classes</p>
</div>
<br>
  <v-card
    class="mx-auto  transition-swing"
    max-width="500"
     :elevation="5" :loading="isLoading" v-if="meetingName"
  >
      <v-row
        justify="space-around"
      >
        <v-col
          class="pl-6"
          cols="3"
        >
          <v-avatar color="indigo"
          size="70">
      <v-icon dark>
        mdi-account-circle
      </v-icon>
    </v-avatar><br/>
       <span>
        {{attendee}}
      </span>
    </v-col>
    <v-col
          align-self="center"
          class="pa-2"
          cols="9"
        >
         <span class="has-text-primary-light is-size-4">{{meetingName}}</span>
        </v-col>
      </v-row>
      <v-card-text>
      <v-row
      >

    <v-col  cols="6">
        <v-icon class="mr-1">
            mdi-timetable
          </v-icon>
          <span class="subheading mr-2">{{meetingTime}}</span>
    </v-col>
    <v-col  cols="6">
        <v-icon class="mr-1">
            mdi-timer
          </v-icon>
          <span class="subheading mr-2"> {{duration}}  minutes</span>
    </v-col>
      </v-row>

      <v-row >
    <v-col  cols="6" v-for="mod in moderator" v-bind:key="mod.userID">
        <v-icon class="mr-1">
            mdi-account
          </v-icon> {{mod.name}}
    </v-col>
      </v-row>

      <v-row >
    <v-col>
       <span class="subheading mr-2">{{description}}</span>
    </v-col>
      </v-row>
    </v-card-text>

    <v-divider></v-divider>
    <v-card-actions>
      <v-row
        align="center"
        justify="space-around"
      >
      <v-btn normal color="success" dark class="font-weight-bold"
                  @click="joinNow"
                  >
              Join Now
            </v-btn>
    </v-row>
    </v-card-actions>
  </v-card>
  <div v-if="!isLoading && !meetingName">
      <section class="container section page-header section is-main-section">
<p class="title is-4" style=" text-align: center;">{{errMessage}}</p>
    </section>
  </div>
  </section>
</template>

<script>

import constants from '@/utils/constants'
import moment from 'moment'
export default {
  components: { },
  name: 'ThankYouPage',

  props: ['referenceID'],
  data: function () {
    return {
      isLoading: false,
      meetingName: null,
      meetingTime: '',
      duration: '',
      attendee: '',
      description: '',
      meetingURL: '',
      errMessage: '',
      moderator: []
    }
  },
  created: async function () {
    await this.getMeetingURL()
  },
  methods: {
    getMeetingURL: async function () {
      try {
        this.loadingComponent = this.$buefy.loading.open()
        this.isLoading = true
        const { data } = await http.get(`${constants.API_URL}/api/online-meeting/join?referenceID=${this.referenceID}`)
        if (data) {
          console.log(data)
          this.meetingName = data.meetingName
          this.duration = data.duration
          this.meetingTime = moment(data.meetingTime).format('LLL')
          this.attendee = data.attendee
          this.meetingURL = data.meetingURL
          this.description = data.description
          this.moderator = data.moderator
        }
        this.isLoading = false
        this.loadingComponent.close()
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log(errorMessage)
        this.isLoading = false
        this.errMessage = errorMessage
        this.loadingComponent.close()
      }
    },
    joinNow: async function () {
      window.open(this.meetingURL)
      this.$router.push({ name: 'onlineClass' })
    },
    errMsg (msg) {
      return this.$buefy.dialog.alert({
        message: msg,
        type: 'is-danger',
        hasIcon: true,
        animation: 'zoom-out',
        size: 'is-medium',
        icon: ' mdi-exclamation',
        iconPack: 'mdi',
        ariaRole: 'alertdialog',
        ariaModal: true
      })
    }
  }
}
</script>
